import {setTransactionDefaults} from "../../../../../utils";
import {
  TRANSACTION_INSTR,
  TRANSACTION_INSTR_ORDERING_FIELD_NAMES,
  TRANSACTION_TYPE_VALUES,
} from "../../../../../constants";
import {getAssetInternalId} from "../../../../../../CustomerDashboard/utils";
import {initEinzeltitelSettings} from "../../../../../../RiskProfiling/einzeltitel_helper";

/**
 * Hook that initializes transaction defaults (transaction_type, deposit_from_type, sell_all)
 * and builds the transactionsByProduct lookup map.
 *
 * This logic runs on every render to ensure new instruments get defaults applied.
 */
const useTransactionSetup = ({portfolio, transactions, isVirtual, quotationFieldsSource, handleSellAllChanged}) => {

  const transactionsByProduct = {};

  [TRANSACTION_TYPE_VALUES.BUY, TRANSACTION_TYPE_VALUES.SELL, TRANSACTION_TYPE_VALUES.SWITCH].forEach(transaction => {
    transactionsByProduct[transaction] = {};
    const availableOrderingFields = portfolio[quotationFieldsSource[transaction]];
    const sellAllAvailable = availableOrderingFields.includes(TRANSACTION_INSTR_ORDERING_FIELD_NAMES.is_all);
    const qtyAvailable = availableOrderingFields.includes(TRANSACTION_INSTR_ORDERING_FIELD_NAMES[TRANSACTION_INSTR.qty]);

    (transactions[transaction] || []).forEach(instr => {
      // FIXME: transaction defaults should be set in initStepAsync and during new instrument add
      setTransactionDefaults(instr, portfolio, transaction, isVirtual)

      // Auto sell-all for wholeDepotOrder instruments
      if (typeof instr.sell_all === 'undefined' && instr.data.wholeDepotOrder && (sellAllAvailable || qtyAvailable)) {
        handleSellAllChanged(instr, true, sellAllAvailable);
      }

      transactionsByProduct[transaction][getAssetInternalId(instr.data)] = instr;
    });
  });

  return {transactionsByProduct};
};

export default useTransactionSetup;
